export const EVENT_VIEWED_CHANGED = 'event-viewed-changed';

export const notifyEventViewedChanged = (eventId) => {
    if (typeof window === 'undefined' || eventId == null || eventId === '') {
        return;
    }
    window.dispatchEvent(new CustomEvent(EVENT_VIEWED_CHANGED, {
        detail: { eventId: String(eventId) },
    }));
};
